<template>
    <div class="app has-header">
        <div class="header main">



            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>


        </div>
        <div class ="tablecontainer scrollbar-container" v-if="!loading">
            <h3 style="color: #6d8d23;">{{ $t('workBalance.accounting.accountingPeriodSettings') }} <i :class="showPeriodSettingTables ? 'fas fa-eye-slash' : 'fas fa-eye'" @click="showPeriodSettingTables = !showPeriodSettingTables"></i></h3>
            <div v-if="showPeriodSettingTables">
                <div v-for="state in accountingPeriodSettingsTableStates" :key="state.name">
                    <h4 >{{state.name}}</h4>
                    <datatable :state="state"/>
                    <br/>
                </div>
            </div>
            <br/>
            <h3 style="color: #6d8d23;">{{ $t('workBalance.accounting.leaveSettings') }} <i :class="showExitTable ? 'fas fa-eye-slash' : 'fas fa-eye'" @click="showExitTable = !showExitTable"></i></h3>
            <div v-if="showExitTable">
                <datatable :state="contractExitSettingTableState"/>
            </div>

        </div>


        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>

        </div>
    </div>

</template>

<script>
import { min } from 'date-fns';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'accountingperiodsettings',
  data () {
    return {
      loading: false,
      showPeriodSettingTables: true,
      showExitTable: true,
     }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  computed: {
    ...mapGetters(['storeId', 'accountingPeriodSettingsMap', 'contractExitSettingMap', 'storeSettings', 'uiDataMap']),
    contractTypes() {
        let types = [];
        this.uiDataMap.contractTypes.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
    exitReasons() {
        let reasons = [];
        this.uiDataMap.exitReasons.forEach(item => {
            if(item.idL != null){
                reasons.push({label: item.label_de, value: item.idL, country: item.country})
            }
        });
        return reasons;
    },
    availableExitReasons() {
        let view = this;
        let reasons = [];

        let forbidden = Object.values(this.contractExitSettingMap).map(i => i.reason);
        this.exitReasons.forEach(r => {
            console.log(r)
            if(!forbidden.includes(r.value) && (r.country == null || view.storeSettings.country == r.country)){
                reasons.push(r);
            }
        })
        return reasons;
    },
    exitReasonIdMap() {
        let map = {};
        this.uiDataMap.exitReasons.forEach(item => {
            if(item.idL != null){
                map[""+item.idL] = item.id;
            }
        });
        return map;
    },
    exitReasonLabelMap() {
        let map = {};
        this.uiDataMap.exitReasons.forEach(item => {
            if(item.idL != null){
                map[""+item.idL] = item.label_de;
            }

        });
        return map;
    },
    employeeCategories() {
        let types = [];
        this.uiDataMap.employeeCategories.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
    employmentTypes() {
        let types = [];
        this.uiDataMap.employmentTypes.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
    employeeLevels() {
        let types = [];
        this.uiDataMap.employeeLevels.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
    months() {
        let months = [];
        for(let i = 0; i<12; i++){
            let month = this.$helpers.getMomentTZ().month(i).format("MMMM");
            let item = {label: month, value: i};
            months.push(item);
        }
        return months;

    },

    accountingPeriodSettingsTableStates(){
        let view = this;
        let states = [];
        let priorities = [];
        Object.values(this.accountingPeriodSettingsMap).forEach(i => {
            if(!priorities.includes(i.priority)){
                priorities.push(i.priority);
            }
        });
        priorities.sort((a,b) => a-b);

        priorities.forEach(p => {
            let state = {};
            let items = Object.values(view.accountingPeriodSettingsMap).filter(i => i.priority == p).sort((a,b) => a.month - b.month);
            state = this.$helpers.GetDataTableStateFromObject({month: 0, compensatePositiveWorkTime: false,
                                                           compensateNegativeWorkTime: false, compensatePositiveHolidays: false,
                                                           compensateNegativeHolidays: false, compensateNightWorkTime: false,
                                                           overTimeMode: 0, compensateMoreTime: false, compensateBonusTime: false}, items);

            let overTimeModes = [this.$t('workBalance.accounting.noAdjustment'), this.$t('workBalance.accounting.balance'), this.$t('workBalance.accounting.upgrade'), this.$t('workBalance.accounting.balanceAndUpgrade')];
            state.name = this.$t('global.ui.prio') + " "+p;

            state.headerMap['month'].sort = true;
            state.headerMap['month'].align = 'center';
            state.headerMap['month'].label = this.$tc('global.general.month');
            state.headerMap['month'].DisplayLabel = (i) => {return view.$helpers.getMomentTZ().month(i.month).format("MMMM")};
            state.headerMap['compensatePositiveWorkTime'].sort = false;
            state.headerMap['compensatePositiveWorkTime'].align = 'center';
            state.headerMap['compensatePositiveWorkTime'].label = this.$t('workBalance.accounting.workTimePlusShort');
            state.headerMap['compensatePositiveWorkTime'].tooltip = this.$t('workBalance.accounting.reconcilePositive');

            state.headerMap['compensateNegativeWorkTime'].sort = false;
            state.headerMap['compensateNegativeWorkTime'].align = 'center';
            state.headerMap['compensateNegativeWorkTime'].label = this.$t('workBalance.accounting.workTimeMinusShort');
            state.headerMap['compensatePositiveWorkTime'].tooltip = this.$t('workBalance.accounting.reconcileNegative');

            state.headerMap['compensatePositiveHolidays'].sort = false;
            state.headerMap['compensatePositiveHolidays'].align = 'center';
            state.headerMap['compensatePositiveHolidays'].label = this.$t('workBalance.accounting.holidayPlusShort');
            state.headerMap['compensatePositiveHolidays'].tooltip = this.$t('workBalance.accounting.reconcilePositiveHolidays');

            state.headerMap['compensateNegativeHolidays'].sort = false;
            state.headerMap['compensateNegativeHolidays'].align = 'center';
            state.headerMap['compensateNegativeHolidays'].label = this.$t('workBalance.accounting.holidayMinusShort');
            state.headerMap['compensateNegativeHolidays'].tooltip = this.$t('workBalance.accounting.reconcileNegativeHolidays');

            state.headerMap['compensateNightWorkTime'].sort = false;
            state.headerMap['compensateNightWorkTime'].align = 'center';
            state.headerMap['compensateNightWorkTime'].label = this.$t('workBalance.accounting.nightHoursShort');
            state.headerMap['compensateNightWorkTime'].tooltip = this.$t('workBalance.payroll.reconcileNightWorkBalance');

            state.headerMap['overTimeMode'].sort = false;
            state.headerMap['overTimeMode'].align = 'center';
            state.headerMap['overTimeMode'].label = this.$t('workBalance.payroll.overTimeShort');
            state.headerMap['overTimeMode'].DisplayLabel = (i) => {

                return overTimeModes[i.overTimeMode];
            };
            state.headerMap['overTimeMode'].tooltip = this.$t('workBalance.accounting.overTimeMode');

            state.headerMap['compensateMoreTime'].sort = false;
            state.headerMap['compensateMoreTime'].align = 'center';
            state.headerMap['compensateMoreTime'].label = this.$t('workBalance.payroll.moreTimeShort');
            state.headerMap['compensateMoreTime'].tooltip = this.$t('workBalance.payroll.reconcileMoreTimeBalance');

            state.headerMap['compensateBonusTime'].sort = false;
            state.headerMap['compensateBonusTime'].align = 'center';
            state.headerMap['compensateBonusTime'].label = this.$t('workBalance.payroll.bonusHoursShort');
            state.headerMap['compensateBonusTime'].tooltip = this.$t('workBalance.payroll.reconcileBonusHoursBalance');




            state.headerMap['actions'] = {align: 'center',
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.EditAccountingPeriodSetting($event, data)},
                    {icon: 'fas fa-trash', action: ($event, data) => view.DeleteAccountingPeriodSetting($event, data)},
                ]
            };
            state.headerMap['actions'].width = '100px';

            states.push(state);
        })



        return states;
    },
    contractExitSettingTableState(){
        let view = this;
        let state = {};
        state = this.$helpers.GetDataTableStateFromObject({reason: 0, compensatePositiveWorkTime: false, compensateNegativeWorkTime: false,
                                                           compensatePositiveHolidays: false, compensateNegativeHolidays: false, compensateNightWorkTime: false,
                                                           overTimeMode: 0, compensateMoreTime: false, compensateBonusTime: false}, Object.values(view.contractExitSettingMap));

        let overTimeModes = [this.$t('workBalance.accounting.noAdjustment'), this.$t('workBalance.accounting.balance'), "Aufwertung", this.$t('workBalance.accounting.balanceAndUpgrade')];

        state.headerMap['reason'].sort = true;
        state.headerMap['reason'].align = 'center';
        state.headerMap['reason'].label = this.$t('global.general.contractEndReason');
        state.headerMap['reason'].DisplayLabel = (i) => {
            let text = view.exitReasonLabelMap[i.reason] ? view.exitReasonLabelMap[i.reason] : "";
            if(text.length > 30){
                text = text.substring(0, 30)+"..."
            }
            return text;
        };
        state.headerMap['reason'].entryTooltip = (i) => {
            let text = view.exitReasonLabelMap[i.reason] ? view.exitReasonLabelMap[i.reason] : "";

            return text;
        };

        state.headerMap['compensatePositiveWorkTime'].sort = false;
        state.headerMap['compensatePositiveWorkTime'].align = 'center';
        state.headerMap['compensatePositiveWorkTime'].label = this.$t('workBalance.accounting.workTimePlusShort');
        state.headerMap['compensatePositiveWorkTime'].tooltip = this.$t('workBalance.accounting.reconcilePositive');

        state.headerMap['compensateNegativeWorkTime'].sort = false;
        state.headerMap['compensateNegativeWorkTime'].align = 'center';
        state.headerMap['compensateNegativeWorkTime'].label = this.$t('workBalance.accounting.workTimeMinusShort');
        state.headerMap['compensatePositiveWorkTime'].tooltip = this.$t('workBalance.accounting.reconcileNegative');

        state.headerMap['compensatePositiveHolidays'].sort = false;
        state.headerMap['compensatePositiveHolidays'].align = 'center';
        state.headerMap['compensatePositiveHolidays'].label = this.$t('workBalance.accounting.holidayPlusShort');
        state.headerMap['compensatePositiveHolidays'].tooltip = this.$t('workBalance.accounting.reconcilePositiveHolidays');

        state.headerMap['compensateNegativeHolidays'].sort = false;
        state.headerMap['compensateNegativeHolidays'].align = 'center';
        state.headerMap['compensateNegativeHolidays'].label = this.$t('workBalance.accounting.holidayMinusShort');
        state.headerMap['compensateNegativeHolidays'].tooltip = this.$t('workBalance.accounting.reconcileNegativeHolidays');

        state.headerMap['compensateNightWorkTime'].sort = false;
        state.headerMap['compensateNightWorkTime'].align = 'center';
        state.headerMap['compensateNightWorkTime'].label = this.$t('workBalance.accounting.nightHoursShort');
        state.headerMap['compensateNightWorkTime'].tooltip = this.$t('workBalance.payroll.reconcileNightWorkBalance');

        state.headerMap['overTimeMode'].sort = false;
        state.headerMap['overTimeMode'].align = 'center';
        state.headerMap['overTimeMode'].label = this.$t('workBalance.payroll.overTimeShort');
        state.headerMap['overTimeMode'].DisplayLabel = (i) => {

            return overTimeModes[i.overTimeMode];
        };
        state.headerMap['overTimeMode'].tooltip = this.$t('workBalance.accounting.overTimeMode');

        state.headerMap['compensateMoreTime'].sort = false;
        state.headerMap['compensateMoreTime'].align = 'center';
        state.headerMap['compensateMoreTime'].label = this.$t('workBalance.payroll.moreTimeShort');
        state.headerMap['compensateMoreTime'].tooltip = this.$t('workBalance.payroll.reconcileMoreTimeBalance');

        state.headerMap['compensateBonusTime'].sort = false;
        state.headerMap['compensateBonusTime'].align = 'center';
        state.headerMap['compensateBonusTime'].label = this.$t('workBalance.payroll.bonusHoursShort');
        state.headerMap['compensateBonusTime'].tooltip = this.$t('workBalance.payroll.reconcileBonusHoursBalance');




        state.headerMap['actions'] = {align: 'center',
            buttons:[
                {icon: 'fas fa-edit', action: ($event, data) => view.EditContractExitSetting($event, data)},
                {icon: 'fas fa-trash', action: ($event, data) => view.DeleteContractExitSetting($event, data)},
            ]
        };
        state.headerMap['actions'].width = '100px';
        return state;
    },
    headerButtons(){

        let view = this;

        let state= {
            buttons: []
        };
        //BUTTON 1




        state.buttons.push({
            type: "block",
            icon: "fa-sync-alt",
            click: () => {
                    view.refresh(true);
            },
            tooltip: this.$t('global.general.refreshData')
        });
        state.buttons.push({
                type: "block green",
                icon: "fa-plus",
                click: ($event) => {view.AddAccountingPeriodSetting($event)},
                tooltip: this.$t('workBalance.accounting.periodSetting'),
                helperText: this.$t('workBalance.accounting.periodSettingHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2047410177"
        });
        state.buttons.push({
                type: "block orange",
                icon: "fa-plus",
                click: ($event) => {view.AddContractExitSetting($event)},
                tooltip: this.$t('workBalance.accounting.periodLeaveSetting'),
                helperText: this.$t('workBalance.accounting.periodLeaveSettingHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2047410177"
        });
        state.helperLinks = [
            {
                title:  this.$t('store.structure.getSupport'),
                helperText:  this.$t('store.structure.getSupportHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                externalLabel:  this.$t('store.structure.getSupportLabel'),
                cancelLabel: this.$t('global.ui.close'),
            }
        ];
        return state;
    },
  },
  watch: {

    storeId: function(val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        view.loading = true;
        view.$helpers.GetUiDataMap()
        .then(response => {
            return view.$helpers.GetAccountingPeriodSettingsMap(true);
        }).then(response => {
            return view.$helpers.GetContractExitSettingMap(true);
        }).then(response => {
           view.loading = false;
        }).catch(function (error) {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
        })

    },
    AddAccountingPeriodSetting($event){
        let view = this;

        let dataFillState = view.$helpers.GetAccountingPeriodSettingState(null, null, null, this.calculateAvailableMonths(), this.contractTypes, this.employeeCategories, this.employmentTypes, this.employeeLevels, this.storeSettings, false, null, (item)  => {
            let temp = Object.assign({}, item);
            delete temp.months;
            let items = [];
            item.months.forEach(m => {
                let r = Object.assign({}, temp);
                r.month = m;
                items.push(r);
            })
            view.createMultiAccountingPeriodSetting(items);
        });

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: dataFillState,
            header: this.$t('workBalance.payroll.addNewConfig'),
            width: "900px",
            expanded: true,
            centered: true
        });
    },
    calculateAvailableMonths(){
        let m = {};
        let maxPriority = 3;
        let minPriority = 1;
        for(let i = minPriority; i<=maxPriority; i++){
            m[i] = [];
            let forbidden = Object.values(this.accountingPeriodSettingsMap).filter(aps => aps.priority == i).map(aps => aps.month);
            this.months.forEach(r => {
                if(!forbidden.includes(r.value)){
                    m[i].push(Object.assign({}, r));
                }
            })
        }

        return m;
    },
    createAccountingPeriodSetting: function(item){
        let view = this;
        let url = '/api/sec/accountingperiodsetting';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {
            minWeekTimeRegular: item.minWeekTimeRegular,
            maxWeekTimeRegular: item.maxWeekTimeRegular,
            month: item.month,
            useContractTypes: item.useContractTypes,
            contractTypes: item.contractTypes,
            employeeCategories: item.employeeCategories,
            employmentTypes: item.employmentTypes,
            employeeLevels: item.employeeLevels,
            useWorkTimeFactor: item.useWorkTimeFactor,
            compensatePositiveWorkTime: item.compensatePositiveWorkTime,
            compensateNegativeWorkTime: item.compensateNegativeWorkTime,
            compensateToContract: item.compensateToContract,
            useHolidayFactor: item.useHolidayFactor,
            useHolidayFactorForPositive: item.useHolidayFactorForPositive,
            useHolidayFactorForNegative: item.useHolidayFactorForNegative,
            compensatePositiveHolidays: item.compensatePositiveHolidays,
            compensateNegativeHolidays: item.compensateNegativeHolidays,
            compensateNightWorkTime: item.compensateNightWorkTime,
            overTimeMode: item.overTimeMode,
            useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
            useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
            useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
            compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
            compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
            applyToUnderage: item.applyToUnderage,
            conditionJoin: item.conditionJoin,
            compensateMoreTime: item.compensateMoreTime,
            compensateBonusTime: item.compensateBonusTime,
            roundUpVacationTime: item.roundUpVacationTime,
            compensateVacationTime: item.compensateVacationTime,
            priority: item.priority,
            workTimeFactor: item.workTimeFactor,
            moreTimeFactor: item.moreTimeFactor,
            endsAccountingPeriod: item.endsAccountingPeriod,
            contractTypeFactorExemption1: item.contractTypeFactorExemption1,
            contractTypeFactorExemption2: item.contractTypeFactorExemption2,
            contractTypeFactorExemption3: item.contractTypeFactorExemption3
        }

        if(Object.values(view.accountingPeriodSettingsMap).filter(i => i.month == payload.month).length > 0){
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.monthHasSettingError'));
        } else {
            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$set(view.accountingPeriodSettingsMap, ''+response.data.data.id, response.data.data);
                view.$store.commit("invalidateState", {states: ["accountingPeriodSettingsMapState"]});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.addedNewConfig'));
            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
            })
        }



    },

    createMultiAccountingPeriodSetting: function(items){
        let view = this;
        let url = '/api/sec/accountingperiodsetting/multi';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {requests:[]}
        items.forEach(item => {
            let req = {
                minWeekTimeRegular: item.minWeekTimeRegular,
                maxWeekTimeRegular: item.maxWeekTimeRegular,
                month: item.month,
                useContractTypes: item.useContractTypes,
                contractTypes: item.contractTypes,
                employeeCategories: item.employeeCategories,
                employmentTypes: item.employmentTypes,
                employeeLevels: item.employeeLevels,
                useWorkTimeFactor: item.useWorkTimeFactor,
                compensatePositiveWorkTime: item.compensatePositiveWorkTime,
                compensateNegativeWorkTime: item.compensateNegativeWorkTime,
                compensateToContract: item.compensateToContract,
                useHolidayFactor: item.useHolidayFactor,
                useHolidayFactorForPositive: item.useHolidayFactorForPositive,
                useHolidayFactorForNegative: item.useHolidayFactorForNegative,
                compensatePositiveHolidays: item.compensatePositiveHolidays,
                compensateNegativeHolidays: item.compensateNegativeHolidays,
                compensateNightWorkTime: item.compensateNightWorkTime,
                overTimeMode: item.overTimeMode,
                useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
                useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
                useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
                compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
                compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
                applyToUnderage: item.applyToUnderage,
                conditionJoin: item.conditionJoin,
                compensateMoreTime: item.compensateMoreTime,
                compensateBonusTime: item.compensateBonusTime,
                roundUpVacationTime: item.roundUpVacationTime,
                compensateVacationTime: item.compensateVacationTime,
                priority: item.priority,
                workTimeFactor: item.workTimeFactor,
                moreTimeFactor: item.moreTimeFactor,
                endsAccountingPeriod: item.endsAccountingPeriod,
                contractTypeFactorExemption1: item.contractTypeFactorExemption1,
                contractTypeFactorExemption2: item.contractTypeFactorExemption2,
                contractTypeFactorExemption3: item.contractTypeFactorExemption3
            }
            payload.requests.push(req);
        })

        if(payload.requests.length > 0){
            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if(response.data.length > 0){
                    response.data.forEach(r => {
                         view.$set(view.accountingPeriodSettingsMap, ''+r.id, r);
                    })
                    view.$store.commit("invalidateState", {states: ["accountingPeriodSettingsMapState"]});
                }


                view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.addedNewConfig'));
            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
            })
        }




    },
    EditAccountingPeriodSetting($event, setting){
        let view = this;

        let dataFillState = view.$helpers.GetAccountingPeriodSettingState(setting, setting.month, setting.priority, this.calculateAvailableMonths(), this.contractTypes, this.employeeCategories, this.employmentTypes, this.employeeLevels, this.storeSettings, false, null, (item)  => {
            view.updateAccountingPeriodSetting(item);
        });
        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: dataFillState,
            header: this.$t('global.ui.editConfig'),
            width: "900px",
            expanded: true,
            centered: true
        });
    },
    updateAccountingPeriodSetting(item) {
        let view = this;
        let url = '/api/sec/accountingperiodsetting';

        let params = {
            storeId: this.$store.state.storeId,
        };
        console.log(item)
        let payload = {
            id: item.id,
            minWeekTimeRegular: item.minWeekTimeRegular,
            maxWeekTimeRegular: item.maxWeekTimeRegular,
            useContractTypes: item.useContractTypes,
            contractTypes: item.contractTypes,
            employeeCategories: item.employeeCategories,
            employmentTypes: item.employmentTypes,
            employeeLevels: item.employeeLevels,
            useWorkTimeFactor: item.useWorkTimeFactor,
            compensatePositiveWorkTime: item.compensatePositiveWorkTime,
            compensateNegativeWorkTime: item.compensateNegativeWorkTime,
            compensateToContract: item.compensateToContract,

            useHolidayFactor: item.useHolidayFactor,
            useHolidayFactorForPositive: item.useHolidayFactorForPositive,
            useHolidayFactorForNegative: item.useHolidayFactorForNegative,
            compensatePositiveHolidays: item.compensatePositiveHolidays,
            compensateNegativeHolidays: item.compensateNegativeHolidays,
            compensateNightWorkTime: item.compensateNightWorkTime,
            overTimeMode: item.overTimeMode,
            useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
            useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
            useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
            compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
            compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
            applyToUnderage: item.applyToUnderage,
            conditionJoin: item.conditionJoin,
            compensateMoreTime: item.compensateMoreTime,
            compensateBonusTime: item.compensateBonusTime,
            roundUpVacationTime: item.roundUpVacationTime,
            compensateVacationTime: item.compensateVacationTime,
            priority: item.priority,
            workTimeFactor: item.workTimeFactor,
            moreTimeFactor: item.moreTimeFactor,
            endsAccountingPeriod: item.endsAccountingPeriod,
            contractTypeFactorExemption1: item.contractTypeFactorExemption1,
            contractTypeFactorExemption2: item.contractTypeFactorExemption2,
            contractTypeFactorExemption3: item.contractTypeFactorExemption3,
            updateFields: ["minWeekTimeRegular", "maxWeekTimeRegular", "useContractTypes", "employeeCategories", "employmentTypes", "employeeLevels",
                           "contractTypes", "useWorkTimeFactor",
                           "compensatePositiveWorkTime", "compensateNegativeWorkTime", "compensateToContract", "compensatePositiveHolidays",
                           "compensateNegativeHolidays", "compensateNightWorkTime", "overTimeMode", "useOvertimeFactorForPositive",
                           "useOvertimeFactorForNegative", "useHolidayFactor", "useHolidayFactorForPositive",
                           "useHolidayFactorForNegative", "compensateWorkTimeWithOvertime", "applyToUnderage", "conditionJoin",
                           "compensateMoreTime", "compensateBonusTime", "compensateNegativeWorkTimeWithOvertime", "priority",
                           "roundUpVacationTime", "compensateVacationTime", "useDeltaOvertimeFactor", 
                           "workTimeFactor", "moreTimeFactor", "endsAccountingPeriod", 
                           "contractTypeFactorExemption1", "contractTypeFactorExemption2", "contractTypeFactorExemption3"

                        ]
        }

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$store.commit("setAccountingPeriodSettingsMapEntry", item);

            view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.editedConfig'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.editError'));
        })
    },
    DeleteAccountingPeriodSetting($event, data){
        let view = this;
        let month = this.$helpers.getMomentTZ().month(data.month).format("MMMM")
        view.$helpers.OpenAlert({header: this.$t('workBalance.payroll.deleteConfig'), description: this.$t('workBalance.accounting.settingDeletionQuery', [month]), callbackAccept: (alert) => {
            alert.hidden = true;
            view.deleteAccountingPeriodSetting(data);
        }});
    },
    deleteAccountingPeriodSetting: function(data){

        let view = this;
        let url = '/api/sec/accountingperiodsetting';

        let params = {
          storeId: this.$store.state.storeId,
          id: data.id
        };


        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$store.commit("deleteAccountingPeriodSettingsMapEntry", {id: data.id});

            view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.settingDeleted'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
        })

    },
    AddContractExitSetting($event){
        let view = this;
        let overTimeModes = [{label: this.$t('workBalance.accounting.noAdjustment'), value: 0}, {label: this.$t('workBalance.accounting.balanceOvertime'), value: 1}, {label: this.$t('workBalance.accounting.addOvertimeUpgradeToBalance'), value: 2}, {label: this.$t('workBalance.accounting.addReconciledOvertimeToBalance'), value: 3}]

        let selectedOverTimeMode = overTimeModes[0];

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: {
                entries: [
                    {label: this.$t('global.general.contractEndReason'), key: 'reasons', hidden: false, type: 'dropdownsearch', value: null,
                    dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: this.availableExitReasons,
                            selectMultiple: true,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                    }},
                    {label: this.$t('workBalance.accounting.useMultiplier'), key: 'useWorkTimeFactor', hidden: !this.storeSettings.enableWorkBalanceMultiplier, type: 'bool', value: false},
                    {label: this.$t('workBalance.accounting.workTimeFactor'), key: 'workTimeFactor', hidden: true, type: 'slider', value: this.storeSettings.workBalanceMultiplier, min:0, max: 200,
                        slider: {
                            min: 0, max: 200, value: this.storeSettings.workBalanceMultiplier, step: 5,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*100.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/100.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = this.storeSettings.workBalanceMultiplier;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.useMoreTimeMultiplier'), key: 'useMoreTimeFactor', hidden: true, type: 'bool', value: false,
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(!useWorkTimeFactor || view.storeSettings.country != 1){
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = false;
                                
                            } else {
                                entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    
                    {label: this.$t('workBalance.accounting.moreTimeFactor'), key: 'moreTimeFactor', hidden: true, type: 'slider', value: 0, 
                        slider: {
                            min: 0, max: 200, value: 0, step: 5,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*100.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/100.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useMoreTimeFactor = datafill.entries.find(i => i.key == 'useMoreTimeFactor').value;

                            if(useMoreTimeFactor){
                                entryBeforeUpdate.hidden = false;
                                if(entryBeforeUpdate.value == 0){
                                    entryBeforeUpdate.value = 125;
                                    entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.contractTypeFactorExemption1'), key: 'contractTypeFactorExemption1', hidden: true, type: 'slider', value: 0, 
                        slider: {
                            min: 0, max: 100*60, value: 0, step: 15,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*60.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.contractTypeFactorExemption2'), key: 'contractTypeFactorExemption2', hidden: true, type: 'slider', value: 0, 
                        slider: {
                            min: 0, max: 100*60, value: 0, step: 15,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*60.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.contractTypeFactorExemption3'), key: 'contractTypeFactorExemption3', hidden: true, type: 'slider', value: 0, 
                        slider: {
                            min: 0, max: 100*60, value: 0, step: 15,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*60.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.reconcilePositive'), key: 'compensatePositiveWorkTime', hidden: false, type: 'bool', value: true, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                        if(useWorkTimeFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.reconcileNegative'), key: 'compensateNegativeWorkTime', hidden: false, type: 'bool', value: true},
                    {label: this.$t('workBalance.accounting.reconcileContractTarget'), key: 'compensateToContract', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                        if(useWorkTimeFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addHolidayHoursToWorkTimeBalance'), key: 'useHolidayFactor', hidden: !this.storeSettings.separateOvertimeHolidayTime, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let compensatePositiveHolidays = datafill.entries.find(i => i.key == 'compensatePositiveHolidays').value;
                        let compensateNegativeHolidays = datafill.entries.find(i => i.key == 'compensateNegativeHolidays').value;

                        if( compensatePositiveHolidays || compensateNegativeHolidays){
                            entryBeforeUpdate.hidden = false;
                            entryBeforeUpdate.value = false;

                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addHolidayHoursToPositiveBalance'), key: 'useHolidayFactorForPositive', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addHolidayHoursToNegativeBalance'), key: 'useHolidayFactorForNegative', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.reconcilePositiveHolidays'), key: 'compensatePositiveHolidays', hidden: false, type: 'bool', value: true, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.reconcileNegativeHolidays'), key: 'compensateNegativeHolidays', hidden: false, type: 'bool', value: true, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.reconcileNightWorkBalance'), key: 'compensateNightWorkTime', hidden: false, type: 'bool', value: true},
                    {label: 'Überstunden Modus', key: 'overTimeMode', hidden: !this.storeSettings.separateOvertimeHolidayTime, type: 'dropdownsearch', value: selectedOverTimeMode.value, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: overTimeModes,
                            selectMultiple: false,
                            selectedItems: [selectedOverTimeMode],
                            selectedItem: selectedOverTimeMode,
                            selectFirst: false,
                            styleLight: true,
                        }
                    },

                    {label: this.$t('workBalance.accounting.addOvertimeToPositiveBalance'), key: 'useOvertimeFactorForPositive', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                        if(matchingMode){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addOvertimeToNegativeBalance'), key: 'useOvertimeFactorForNegative', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                        if(matchingMode){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.useDeltaOverTimeFactor'), key: 'useDeltaOvertimeFactor', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                        if(matchingMode){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},

                    {label: this.$t('workBalance.payroll.overtimePositiveWorkTime'), key: 'compensateWorkTimeWithOvertime', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 1;

                        if(!matchingMode){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.overtimeNegativeWorkTime'), key: 'compensateNegativeWorkTimeWithOvertime', hidden: true, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 1;

                        if(!matchingMode){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.reconcileMoreTimeBalance'), key: 'compensateMoreTime', hidden: false, type: 'bool', value: true},
                    {label: this.$t('workBalance.payroll.reconcileBonusHoursBalance'), key: 'compensateBonusTime', hidden: false, type: 'bool', value: true},
                    {label: this.$t('workBalance.accounting.roundPositiveVacationBalance'), key: 'roundUpVacationTime', hidden: false, type: 'bool', value: false},
                    {label: this.$t('workBalance.accounting.reconcileVacationBalance'), key: 'compensateVacationTime', hidden: false, type: 'bool', value: false},
                    {label: this.$t('workBalance.accounting.endsAccountingPeriod'), key: 'endsAccountingPeriod', hidden: false, type: 'bool', value: true},
            

                ],
                selectCallback: function (item) {
                    let temp = Object.assign({}, item);
                    delete temp.reasons;
                    let items = [];
                    item.reasons.forEach(reason => {
                        let r = Object.assign({}, temp);
                        r.reason = reason;
                        items.push(r);
                    })
                    view.createMultiContractExitSetting(items);
                }
            },
            header: this.$t('workBalance.accounting.addLeaveSetting'),
            width: "1000px",
            expanded: true,
            centered: true
        });
    },
    createContractExitSetting: function(item){
        let view = this;
        let url = '/api/sec/contractexitsetting';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {
            reason: item.reason,
            useWorkTimeFactor: item.useWorkTimeFactor,
            compensatePositiveWorkTime: item.compensatePositiveWorkTime,
            compensateNegativeWorkTime: item.compensateNegativeWorkTime,
            compensateToContract: item.compensateToContract,
            useHolidayFactor: item.useHolidayFactor,
            useHolidayFactorForPositive: item.useHolidayFactorForPositive,
            useHolidayFactorForNegative: item.useHolidayFactorForNegative,
            compensatePositiveHolidays: item.compensatePositiveHolidays,
            compensateNegativeHolidays: item.compensateNegativeHolidays,
            compensateNightWorkTime: item.compensateNightWorkTime,
            overTimeMode: item.overTimeMode,
            useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
            useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
            useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
            compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
            compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
            roundUpVacationTime: item.roundUpVacationTime,
            compensateVacationTime: item.compensateVacationTime,
            compensateMoreTime: item.compensateMoreTime,
            compensateBonusTime: item.compensateBonusTime,
            workTimeFactor: item.workTimeFactor,
            moreTimeFactor: item.moreTimeFactor,
            endsAccountingPeriod: item.endsAccountingPeriod,
            contractTypeFactorExemption1: item.contractTypeFactorExemption1,
            contractTypeFactorExemption2: item.contractTypeFactorExemption2,
            contractTypeFactorExemption3: item.contractTypeFactorExemption3,
        }

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$set(view.contractExitSettingMap, ''+response.data.data.id, response.data.data);
            view.$store.commit("invalidateState", {states: ["contractExitSettingMapState"]});
            view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.addedNewConfig'));
        }).catch(function (error) {

            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
        })



    },
    createMultiContractExitSetting: function(items){
        let view = this;
        let url = '/api/sec/contractexitsetting/multi';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {requests:[]}
        items.forEach(item => {
            let req = {
                reason: item.reason,
                useWorkTimeFactor: item.useWorkTimeFactor,
                compensatePositiveWorkTime: item.compensatePositiveWorkTime,
                compensateNegativeWorkTime: item.compensateNegativeWorkTime,
                compensateToContract: item.compensateToContract,
                useHolidayFactor: item.useHolidayFactor,
                useHolidayFactorForPositive: item.useHolidayFactorForPositive,
                useHolidayFactorForNegative: item.useHolidayFactorForNegative,
                compensatePositiveHolidays: item.compensatePositiveHolidays,
                compensateNegativeHolidays: item.compensateNegativeHolidays,
                compensateNightWorkTime: item.compensateNightWorkTime,
                overTimeMode: item.overTimeMode,
                useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
                useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
                useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
                compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
                compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
                roundUpVacationTime: item.roundUpVacationTime,
                compensateVacationTime: item.compensateVacationTime,
                compensateMoreTime: item.compensateMoreTime,
                compensateBonusTime: item.compensateBonusTime,
                workTimeFactor: item.workTimeFactor,
                moreTimeFactor: item.moreTimeFactor,
                endsAccountingPeriod: item.endsAccountingPeriod,
                contractTypeFactorExemption1: item.contractTypeFactorExemption1,
                contractTypeFactorExemption2: item.contractTypeFactorExemption2,
                contractTypeFactorExemption3: item.contractTypeFactorExemption3,
            }
            payload.requests.push(req);
        })

        if(payload.requests.length > 0){
            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if(response.data.length > 0){
                    response.data.forEach(r => {
                         view.$set(view.contractExitSettingMap, ''+r.id, r);
                    })
                    view.$store.commit("invalidateState", {states: ["contractExitSettingMapState"]});
                }


                view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.addedNewConfig'));
            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
            })
        }




    },
    EditContractExitSetting($event, setting){
        let view = this;
        let overTimeModes = [{label: this.$t('workBalance.accounting.noAdjustment'), value: 0}, {label: this.$t('workBalance.accounting.balanceOvertime'), value: 1}, {label: this.$t('workBalance.accounting.addOvertimeUpgradeToBalance'), value: 2}, {label: this.$t('workBalance.accounting.addReconciledOvertimeToBalance'), value: 3}]


        let selectedOverTimeMode = setting != null ? overTimeModes.find(m => m.value == setting.overTimeMode) : overTimeModes[0];

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: {
                entries: [
                    {label: 'Id', key: 'id', hidden: true, type: 'text', value: setting.id},
                    {label: this.$t('global.ui.reason'), key: 'reason', hidden: true, type: 'numerical', value: setting.reason},
                    {label: this.$t('workBalance.accounting.useMultiplier'), key: 'useWorkTimeFactor', hidden: !this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor, type: 'bool', value: setting.useWorkTimeFactor},
                    {label: this.$t('workBalance.accounting.workTimeFactor'), key: 'workTimeFactor', hidden: !this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor, type: 'slider', value: setting.workTimeFactor, min:0, max: 200,
                        slider: {
                            min: 0, max: 200, value: setting.workTimeFactor, step: 5,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*100.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/100.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = this.storeSettings.workBalanceMultiplier;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.useMoreTimeMultiplier'), key: 'useMoreTimeFactor', hidden: !this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor, type: 'bool', value: setting.moreTimeFactor > 0,
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(!useWorkTimeFactor || view.storeSettings.country != 1){
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = false;
                                
                            } else {
                                entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    
                    {label: this.$t('workBalance.accounting.moreTimeFactor'), key: 'moreTimeFactor', hidden: (!this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor) || setting.moreTimeFactor == 0, type: 'slider', value: setting.moreTimeFactor, 
                        slider: {
                            min: 0, max: 200, value: setting.moreTimeFactor, step: 5,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*100.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/100.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useMoreTimeFactor = datafill.entries.find(i => i.key == 'useMoreTimeFactor').value;

                            if(useMoreTimeFactor){
                                entryBeforeUpdate.hidden = false;
                                if(entryBeforeUpdate.value == 0){
                                    entryBeforeUpdate.value = 125;
                                    entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.contractTypeFactorExemption1'), key: 'contractTypeFactorExemption1', hidden: !this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor, type: 'slider', value: setting.contractTypeFactorExemption1, 
                        slider: {
                            min: 0, max: 100*60, value: setting.contractTypeFactorExemption1, step: 15,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*60.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.contractTypeFactorExemption2'), key: 'contractTypeFactorExemption2', hidden: !this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor, type: 'slider', value: setting.contractTypeFactorExemption2, 
                        slider: {
                            min: 0, max: 100*60, value: setting.contractTypeFactorExemption2, step: 15,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*60.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.contractTypeFactorExemption3'), key: 'contractTypeFactorExemption3', hidden: !this.storeSettings.enableWorkBalanceMultiplier && !setting.useWorkTimeFactor, type: 'slider', value: setting.contractTypeFactorExemption3, 
                        slider: {
                            min: 0, max: 100*60, value: setting.contractTypeFactorExemption3, step: 15,
                            inputControl: true, 
                            sliderInput: (x) => {return Math.round(x*60.0)},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                            if(useWorkTimeFactor){
                                entryBeforeUpdate.hidden = false;
                            } else {
                                entryBeforeUpdate.hidden = true;
                                entryBeforeUpdate.value = 0;
                                entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('workBalance.accounting.reconcilePositive'), key: 'compensatePositiveWorkTime', hidden: setting.useWorkTimeFactor, type: 'bool', value: setting.compensatePositiveWorkTime, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                        if(useWorkTimeFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.reconcileNegative'), key: 'compensateNegativeWorkTime', hidden: false, type: 'bool', value: setting.compensateNegativeWorkTime},
                    {label: this.$t('workBalance.accounting.reconcileContractTarget'), key: 'compensateToContract', hidden: true, type: 'bool', value: setting.compensateToContract, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                        if(useWorkTimeFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addHolidayHoursToWorkTimeBalance'), key: 'useHolidayFactor', hidden: !this.storeSettings.separateOvertimeHolidayTime, type: 'bool', value: setting.useHolidayFactor, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let compensatePositiveHolidays = datafill.entries.find(i => i.key == 'compensatePositiveHolidays').value;
                        let compensateNegativeHolidays = datafill.entries.find(i => i.key == 'compensateNegativeHolidays').value;

                        if( compensatePositiveHolidays || compensateNegativeHolidays){
                            entryBeforeUpdate.value = false;

                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addHolidayHoursToPositiveBalance'), key: 'useHolidayFactorForPositive', hidden: !setting.useHolidayFactor, type: 'bool', value: setting.useHolidayFactorForPositive, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addHolidayHoursToNegativeBalance'), key: 'useHolidayFactorForNegative', hidden: !setting.useHolidayFactor, type: 'bool', value: setting.useHolidayFactorForNegative, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.reconcilePositiveHolidays'), key: 'compensatePositiveHolidays', hidden: setting.useHolidayFactor, type: 'bool', value: setting.compensatePositiveHolidays, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.reconcileNegativeHolidays'), key: 'compensateNegativeHolidays', hidden: setting.useHolidayFactor, type: 'bool', value: setting.compensateNegativeHolidays, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                        if(useHolidayFactor){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.reconcileNightWorkBalance'), key: 'compensateNightWorkTime', hidden: false, type: 'bool', value: setting.compensateNightWorkTime},
                    {label: 'Überstunden Modus', key: 'overTimeMode', hidden: !this.storeSettings.separateOvertimeHolidayTime, type: 'dropdownsearch', value: selectedOverTimeMode.value, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: overTimeModes,
                            selectMultiple: false,
                            selectedItems: [selectedOverTimeMode],
                            selectedItem: selectedOverTimeMode,
                            selectFirst: false,
                            styleLight: true,
                        }
                    },

                    {label: this.$t('workBalance.accounting.addOvertimeToPositiveBalance'), key: 'useOvertimeFactorForPositive', hidden: !(setting.overTimeMode == 2), type: 'bool', value: setting.useOvertimeFactorForPositive, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                        if(matchingMode){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.accounting.addOvertimeToNegativeBalance'), key: 'useOvertimeFactorForNegative', hidden: !(setting.overTimeMode == 2), type: 'bool', value: setting.useOvertimeFactorForNegative, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                        if(matchingMode){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.useDeltaOverTimeFactor'), key: 'useDeltaOvertimeFactor', hidden: !(setting.overTimeMode == 2), type: 'bool', value: setting.useDeltaOvertimeFactor, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                        if(matchingMode){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }},

                    {label: this.$t('workBalance.payroll.overtimePositiveWorkTime'), key: 'compensateWorkTimeWithOvertime', hidden: !(setting.overTimeMode == 1), type: 'bool', value: setting.compensateWorkTimeWithOvertime, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 1;

                        if(!matchingMode){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.overtimeNegativeWorkTime'), key: 'compensateNegativeWorkTimeWithOvertime', hidden: !(setting.overTimeMode == 1), type: 'bool', value: setting.compensateNegativeWorkTimeWithOvertime, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 1;

                        if(!matchingMode){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                    {label: this.$t('workBalance.payroll.reconcileMoreTimeBalance'), key: 'compensateMoreTime', hidden: false, type: 'bool', value: setting.compensateMoreTime},
                    {label: this.$t('workBalance.payroll.reconcileBonusHoursBalance'), key: 'compensateBonusTime', hidden: false, type: 'bool', value: setting.compensateBonusTime},
                    {label: this.$t('workBalance.accounting.roundPositiveVacationBalance'), key: 'roundUpVacationTime', hidden: false, type: 'bool', value: setting.roundUpVacationTime},
                    {label: this.$t('workBalance.accounting.reconcileVacationBalance'), key: 'compensateVacationTime', hidden: false, type: 'bool', value: setting.compensateVacationTime},
                    {label: this.$t('workBalance.accounting.endsAccountingPeriod'), key: 'endsAccountingPeriod', hidden: false, type: 'bool', value: setting.endsAccountingPeriod},
            

                ],
                selectCallback: function (item) {
                    view.updateContractExitSetting(item);
                }
            },
            header: this.$t('global.ui.editConfig'),
            width: "700px",
            expanded: true,
            centered: true
        });
    },
    updateContractExitSetting(item) {
        let view = this;
        let url = '/api/sec/contractexitsetting';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {
            id: item.id,
            useWorkTimeFactor: item.useWorkTimeFactor,
            compensatePositiveWorkTime: item.compensatePositiveWorkTime,
            compensateNegativeWorkTime: item.compensateNegativeWorkTime,
            compensateToContract: item.compensateToContract,

            useHolidayFactor: item.useHolidayFactor,
            useHolidayFactorForPositive: item.useHolidayFactorForPositive,
            useHolidayFactorForNegative: item.useHolidayFactorForNegative,
            compensatePositiveHolidays: item.compensatePositiveHolidays,
            compensateNegativeHolidays: item.compensateNegativeHolidays,
            compensateNightWorkTime: item.compensateNightWorkTime,
            overTimeMode: item.overTimeMode,
            useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
            useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
            useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
            compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
            compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
            roundUpVacationTime: item.roundUpVacationTime,
            compensateVacationTime: item.compensateVacationTime,
            compensateMoreTime: item.compensateMoreTime,
            compensateBonusTime: item.compensateBonusTime,
            workTimeFactor: item.workTimeFactor,
            moreTimeFactor: item.moreTimeFactor,
            endsAccountingPeriod: item.endsAccountingPeriod,
            contractTypeFactorExemption1: item.contractTypeFactorExemption1,
            contractTypeFactorExemption2: item.contractTypeFactorExemption2,
            contractTypeFactorExemption3: item.contractTypeFactorExemption3,
            updateFields: [
                           "useWorkTimeFactor",
                           "compensatePositiveWorkTime", "compensateNegativeWorkTime", "compensateToContract", "compensatePositiveHolidays",
                           "compensateNegativeHolidays", "compensateNightWorkTime", "overTimeMode", "useOvertimeFactorForPositive",
                           "useOvertimeFactorForNegative", "useHolidayFactor", "useHolidayFactorForPositive",
                           "useHolidayFactorForNegative", "compensateWorkTimeWithOvertime", "roundUpVacationTime", "compensateVacationTime",
                           "compensateMoreTime", "compensateBonusTime", "compensateNegativeWorkTimeWithOvertime", "useDeltaOvertimeFactor",
                           "workTimeFactor", "moreTimeFactor", "endsAccountingPeriod", 
                           "contractTypeFactorExemption1", "contractTypeFactorExemption2", "contractTypeFactorExemption3"
                        ]
        }

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$store.commit("setContractExitSettingMapEntry", item);

            view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.editedConfig'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.editError'));
        })
    },
    DeleteContractExitSetting($event, data){
        let view = this;

        view.$helpers.OpenAlert({header: this.$t('workBalance.payroll.deleteConfig'), description: 'Sind Sie sicher dass Sie die Einstellung löschen wollen?', callbackAccept: (alert) => {
            alert.hidden = true;
            view.deleteContractExitSetting(data);
        }});
    },
    deleteContractExitSetting: function(data){

        let view = this;
        let url = '/api/sec/contractexitsetting';

        let params = {
          storeId: this.$store.state.storeId,
          id: data.id
        };


        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$store.commit("deleteContractExitSettingMapEntry", {id: data.id});

            view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.settingDeleted'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
        })

    },

  },

}
</script>


<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }

    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .loading{

        -webkit-filter: none !important;
        filter: none !important;
        position: absolute;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        bottom: 0;
        left: 0;
        top: initial;
        width: 100%;
        height: calc(100vh - 109px);
        background: rgba(0,0,0,.5);
        z-index: 10;
        position: fixed;
    }

    .header > .header.date{
        width: fit-content;
    }

    .paging{
        top: 0;
        bottom: 0;
        right: 250px;
    }

    .header > .text-filter{
        top: 0;
        bottom: 0;
        width: 230px;
        right: 45px;
    }

</style>
